import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageTitleModule } from '@studiobuki/web-core/lib/image-title';
import { DialogsModule } from '@studiobuki/web-core/lib/dialogs';
import { FormTestButtonsModule } from '@studiobuki/web-core/lib/form-test-buttons';
import { FormEmailModule } from '@studiobuki/web-core/lib/form-email';
import { FormStripeAddressModule } from '@studiobuki/web-core/lib/form-stripe-address';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { InputModule } from '@studiobuki/web-core/lib/input';
import { FormGiftSpecialModule } from '@studiobuki/web-core/lib/form-gift-special';
import { FormShipFromModule } from '@studiobuki/web-core/lib/form-ship-from';
import { SectionGiftCheckoutComponent } from './section-gift-checkout.component';
import { FormCheckoutModule } from '../form-checkout/form-checkout.module';
import { AliasSelectComponent } from './components/alias-select/alias-select.component';

@NgModule({
  declarations: [SectionGiftCheckoutComponent, AliasSelectComponent],
  imports: [
    CommonModule,
    ImageTitleModule,
    FormShipFromModule,
    DialogsModule,
    FormTestButtonsModule,
    FormGiftSpecialModule,
    FormEmailModule,
    FormStripeAddressModule,
    FormCheckoutModule,
    ButtonModule,
    InputModule,
  ],
  exports: [SectionGiftCheckoutComponent],
})
export class SectionGiftCheckoutModule {}
